import { Component, OnInit, OnDestroy } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { AuthenticationService } from '../../services/authentication.service';
import { Product } from '../../../agatextscreens/purchasing/products/product';
import { ProductService } from '../../../agatextscreens/purchasing/products/product.service';
import { CollectionService } from '../../services/collection.service';
import { Subscription } from 'rxjs/Subscription';
import { TdDialogService } from '@covalent/core';


@Component({
  selector: 'app-new-received-piece',
  templateUrl: './new-received-piece.component.html',
  styleUrls: ['./new-received-piece.component.scss'],
  providers: [CollectionService, ProductService]
})
export class NewReceivedPieceComponent implements OnInit, OnDestroy {
  _subscription: Subscription = new Subscription();
  prod: string;

  allProducts: Product[] = [];
  matchingProducts: Product[] = [];

  piece: any = {};
  /*
  allCollections: { id: number, name: string }[] = [];
  allDesigns: { id: number, name: string }[] = [];
  allColors: { id: number, name: string }[] = [];
  */

  constructor(public _ref: MdDialogRef<NewReceivedPieceComponent>,
    private _productService: ProductService,
    private _collectionService: CollectionService,
    public _authService: AuthenticationService,
    private _dialogService: TdDialogService) { }

  ngOnInit() {
    /*
    this._subscription.add(
      this._collectionService.getCollections().subscribe(
        cList => this.allCollections = cList.map(c => ({ id: c.id, name: c.name }))
      )
    );
    */

    this._subscription.add(this._productService
      .getProducts()
      .subscribe((products: Product[]) => {
        this.allProducts = products;
        this.matchingProducts = products.slice(0,250);

        //this._loadingService.resolve('loading');
      })
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }


  setSelected(product: Product) {
    //this.selectedProduct = product;
    this.piece.color_id = product.id;
  }


  filterProducts(input: string) {

    console.log('input: ' + input);

      this.matchingProducts = this.allProducts.filter(
        (prod: Product) => {
          let full_name = prod.collection_name + ' - ' + prod.design_name + '/' + prod.name;
          return full_name.toLowerCase().includes(input.toLowerCase());
        }
      ).slice(0,250);

  }



  confirm() {
    console.log(this.piece);

    if (!this.piece.piece_no
      // || !this.piece.fabric_type
      // || !this.piece.collection
      // || !this.piece.design
      // || !this.piece.color
      || !this.piece.color_id
      || !this.piece.length
      || !this.piece.weight) {
      this._dialogService.openAlert({ title: 'Invalid data', message: 'You are missing mandatory information' })
    } else {
      this._ref.close(this.piece)
    }
  }

  /*
  collectionList() {
    return this.allCollections.map(c => c.name);
  }

  designList() {
    return this.allDesigns.map(c => c.name);
  }

  colorList() {
    return this.allColors.map(c => c.name);
  }

  getCollectionId(name: string) {
    return (this.allCollections.find(c => { return name == c.name }) || { id: 0 }).id;
  }

  getDesignId(name: string) {
    return (this.allDesigns.find(c => { return name == c.name }) || { id: 0 }).id;
  }

  loadDesigns($event) {
    this._subscription.add(
      this._productService.getDesignsPerCollection(this.getCollectionId($event)).subscribe(
        dList => this.allDesigns = dList
      )
    )
  }

  loadColors($event) {
    this._subscription.add(
      this._productService.getColorsPerDesign(this.getDesignId($event)).subscribe(
        colorList => this.allColors = colorList
      )
    )
  }
  */
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/dialogs/new-received-piece/new-received-piece.component.ts